import { render, staticRenderFns } from "./ListRegisterRequests.vue?vue&type=template&id=121ad1e5&scoped=true&"
import script from "./ListRegisterRequests.vue?vue&type=script&lang=js&"
export * from "./ListRegisterRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ad1e5",
  null
  
)

export default component.exports